import { api } from "./api";
import { GET_PAYMENTS } from "../apiEndPoints";

export const paymentApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getPayments: builder.query({
      query: (student_id) => ({
        url: `${GET_PAYMENTS}/${student_id}/payment-records`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPaymentsQuery } = paymentApiSlice;
